
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 -6.5 36 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.892.29L.35 10.742l-.059.054a.984.984 0 00-.291.642v.124a.98.98 0 00.291.642l.052.044L10.892 22.71c.39.387 1.023.387 1.413 0a.985.985 0 000-1.402l-9.008-8.934h31.704a.994.994 0 00.999-.99.995.995 0 00-1-.992H3.533l8.773-8.7a.985.985 0 000-1.402 1.005 1.005 0 00-1.413 0zM.885 11.383l10.714 10.626L.998 11.5v-.004l.059-.053.06-.06H.885z","fill":"#252528"}})])
          )
        }
      }
    